import m from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'

import s from './unstyled-button.module.css'

interface Attrs extends m.Attributes {
	type?: 'button' | 'submit'
	className?: string
}

const UnstyledButton = initMithrilComponent<Attrs>()

UnstyledButton.view = (vnode) => {
	const { type = 'button', className = '', ...passthru_attrs } = vnode.attrs

	return (
		<button type={type} className={clsx(s.unstyled_button, className)} {...passthru_attrs}>
			{vnode.children}
		</button>
	)
}

export default UnstyledButton
